
import { Component, Vue } from 'vue-property-decorator'
import BonusPool from '@/components/pc/BonusPool.vue'

@Component({
  name: 'videoPage',
  components: {
    BonusPool
  },
})
export default class App extends Vue {
}
